'use strict'

loadAsyncJS = require('./m_loadAsyncJS')
{ unescape } = require './m_underscore_replacements'
{ readLdJSON } = require('./m_readLdJSON')

((gtm) ->
  gtmData = readLdJSON 'gtmData'
  cCookie = window.Cookie.get 'c'
  eCookie = window.Cookie.get 'e'
  if (gtmData.data)
    try
      gtm = JSON.parse(unescape(unescape(gtmData.data)))

  if (cCookie isnt null and eCookie isnt null)
    gtm.dl_user_id = cCookie
    gtm.dl_email_sha256 = eCookie

  gtm.platform = gtmData.platform
  window.dataLayer = [gtm]
  if (gtmData.enabled)
    loadGTM = ->
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      })
      src = new URL('https://www.googletagmanager.com/gtm.js')
      if (gtmData.id)
        src.searchParams.set('id', gtmData.id)
      loadAsyncJS src.toString()
    window.addEventListener 'load', loadGTM, { passive: true, once: true }
)({})



// WEBPACK FOOTER //
// ./src/frontend/helper/general/m_googleTagManager.coffee